// @flow
import { useCallback, useEffect } from 'react';

import SimpleDate from 'app/dataProviders/SimpleDate';


type Options = {
  klassId: null | string,
  date: null | SimpleDate,
  redirect: ({ +date?: string, +klassId: string }, writeHistory?: boolean) => void,
  dateFormat: string,
}


export default function useRedirect({ klassId, date, redirect, dateFormat }: Options): {
  changeKlass: (id: string) => void,
  changeDate: (date: SimpleDate) => void,
} {
  useEffect(() => {
    const dateValidFormatted = date ? date.getString(dateFormat) : null;
    if (klassId && dateValidFormatted) {
      redirect({ klassId, date: dateValidFormatted });
    }
  }, [klassId, date, dateFormat]); // eslint-disable-line react-hooks/exhaustive-deps

  const changeKlass = useCallback((id: string) => {
    if (date) {
      redirect({ date: date.getString(dateFormat), klassId: id }, true);
      return;
    }
    redirect({ klassId: id }, true);
  }, [redirect, date, dateFormat]);

  const changeDate = useCallback((dt: SimpleDate) => {
    if (klassId && dt.getIsValid()) {
      redirect({ date: dt.getString(dateFormat), klassId }, true);
    }
  }, [klassId, redirect, dateFormat]);

  return {
    changeKlass,
    changeDate,
  };
}
